import RegisterField, { FieldProps } from "../register-field";
import { MontoField, MontoFieldProps } from "@/components/inputs";

export default function FormMontoField({
    name,
    registerOptions,
    ...props
}: FieldProps<MontoFieldProps>) {
    return <RegisterField name={name} disabled={props.disabled} {...registerOptions}>
        {field => <MontoField
            {...props}

            inputRef={field.ref}
            value={field.value}
            disabled={field.disabled}

            onValueChange={v => {
                field.handleChange(v);
                props.onValueChange && props.onValueChange(v);
            }}
            onBlur={e => {
                field.handleBlur();
                props.onBlur && props.onBlur(e);
            }}
            onKeyDown={e => {
                props.onKeyDown && props.onKeyDown(e);
                field.handleKeyDown(e);
            }}

            error={field.hasError}
            helperText={field.errorMessage}
        />}
    </RegisterField>
}